const COLORS = ['#c4a35a', '#f4efe6', '#2f6f4e', '#8c3a3a', '#e7d7a1', '#ffffff'];

export const SHUTDOWN_TITLE = 'Technical issues';
export const SHUTDOWN_MESSAGE = 'ReadTheWord is temporarily unavailable while we fix a technical issue. Please check back soon.';

function platformEvent(events, type, platform) {
  if (!Array.isArray(events)) return null;
  return events.find((event) => (
    event
    && event.type === type
    && Array.isArray(event.platforms)
    && event.platforms.includes(platform)
  )) || null;
}

export function webConfettiEvent(events) {
  return platformEvent(events, 'confetti', 'web');
}

export function webShutdownEvent(events) {
  return platformEvent(events, 'app_disabled', 'web');
}

export function webWarningEvent(events) {
  return platformEvent(events, 'warning', 'web');
}

export const WARNING_TITLE = 'We\'re falling behind';
export const WARNING_MESSAGE = 'We lose the season if the reading stops. Open a chapter and keep going.';

export function warningCopy(event) {
  const title = typeof event?.title === 'string' ? event.title.trim() : '';
  const message = typeof event?.message === 'string' ? event.message.trim() : '';
  return {
    title: title || WARNING_TITLE,
    message: message || WARNING_MESSAGE
  };
}

export function shutdownCopy(event) {
  const title = typeof event?.title === 'string' ? event.title.trim() : '';
  const message = typeof event?.message === 'string' ? event.message.trim() : '';
  return {
    title: title || SHUTDOWN_TITLE,
    message: message || SHUTDOWN_MESSAGE
  };
}

const piece = (width) => ({
  x: Math.random() * width,
  y: -20 - Math.random() * 40,
  vx: (Math.random() - 0.5) * 2.2,
  vy: 1.6 + Math.random() * 2.4,
  size: 6 + Math.random() * 7,
  color: COLORS[Math.floor(Math.random() * COLORS.length)],
  tilt: Math.random() * Math.PI,
  spin: (Math.random() - 0.5) * 0.2,
  shape: Math.random() > 0.5 ? 'rect' : 'ribbon'
});

// Draws until stop() is called. Pieces fall while the confetti event is active.
export function runConfetti(canvas) {
  const context = canvas.getContext('2d');
  let pieces = [];
  let frame = 0;
  let running = true;

  const resize = () => {
    const ratio = window.devicePixelRatio || 1;
    canvas.width = Math.floor(window.innerWidth * ratio);
    canvas.height = Math.floor(window.innerHeight * ratio);
    context.setTransform(ratio, 0, 0, ratio, 0, 0);
  };

  const spawn = (count) => {
    const width = window.innerWidth;
    for (let index = 0; index < count; index += 1) {
      pieces.push(piece(width));
    }
  };

  resize();
  spawn(90);
  window.addEventListener('resize', resize);

  const draw = () => {
    if (!running) return;
    const width = window.innerWidth;
    const height = window.innerHeight;
    context.clearRect(0, 0, width, height);

    if (frame % 28 === 0 && pieces.length < 180) spawn(14);
    frame += 1;

    pieces = pieces.filter((item) => item.y < height + 30);
    for (const item of pieces) {
      item.x += item.vx;
      item.y += item.vy;
      item.tilt += item.spin;
      item.vy += 0.025;
      context.save();
      context.translate(item.x, item.y);
      context.rotate(item.tilt);
      context.fillStyle = item.color;
      if (item.shape === 'rect') {
        context.fillRect(-item.size / 2, -item.size / 4, item.size, item.size / 2);
      } else {
        context.fillRect(-item.size / 6, -item.size / 2, item.size / 3, item.size);
      }
      context.restore();
    }

    requestAnimationFrame(draw);
  };

  requestAnimationFrame(draw);

  return () => {
    running = false;
    window.removeEventListener('resize', resize);
    context.clearRect(0, 0, window.innerWidth, window.innerHeight);
  };
}
